/* ChroMorpher - PDP behaviour.
   Two small features, no libraries, no external requests:
     1. Sticky add-to-cart bar that mirrors Dawn's real product form.
     2. Expand/collapse for the product description.
   Everything degrades to a working page if JS never runs: the sticky bar starts
   hidden and the description starts expanded when JS is absent (see the inline
   data-collapsed set by the snippet only after this script boots). */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  /* The sticky add-to-cart bar now lives in assets/cm-sticky.js (loaded by
     snippets/cmx-sticky.liquid) so the default product template can use it too. */

  /* ---------------- Description expander ---------------- */
  function initDesc() {
    document.querySelectorAll('[data-cmx-desc]').forEach(function (wrap) {
      var body = wrap.querySelector('[data-cmx-desc-body]');
      var btn = wrap.querySelector('[data-cmx-desc-more]');
      if (!body || !btn) return;
      // Only collapse when there is genuinely more to reveal.
      if (body.scrollHeight <= 170) { btn.hidden = true; return; }
      body.setAttribute('data-collapsed', 'true');
      btn.hidden = false;
      btn.addEventListener('click', function () {
        var collapsed = body.getAttribute('data-collapsed') === 'true';
        body.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
        btn.textContent = collapsed ? btn.getAttribute('data-less') : btn.getAttribute('data-more');
      });
    });
  }

  /* ---------------- Hide meaningless variant selectors ----------------
     A few products carry a single option literally named "Title" with one value.
     Dawn only auto-hides the true default-variant case, so that leaves a dropdown
     with exactly one choice, which reads as a decision the buyer has to make. */
  function initSelectors() {
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (vs) {
      vs.querySelectorAll('.product-form__input').forEach(function (field) {
        var select = field.querySelector('select');
        var radios = field.querySelectorAll('input[type="radio"]');
        // One option value is not a choice - it is noise above the Add to cart button.
        var only = (select && select.options.length <= 1) || (!select && radios.length === 1);
        if (only) field.hidden = true;
      });
    });
  }

  /* ---------------- Size guide -> variant selector ----------------
     The size cards are a buying aid, so clicking one should actually do the
     thing: select the first purchasable size at that width and take the buyer
     back to the buy box. Falls back to a plain scroll if the option is not
     a <select> (radio pickers) or the width no longer exists. */
  function initSizePicker() {
    var cards = document.querySelectorAll('[data-cmx-pick-size]');
    if (!cards.length) return;

    function widthOf(text) {
      return String(text).replace(/[×x]/gi, ' X ').trim().split(' ')[0].trim();
    }

    cards.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var want = btn.getAttribute('data-cmx-pick-size');
        var selects = document.querySelectorAll('variant-selects select');
        selects.forEach(function (sel) {
          var label = (sel.name || '') + ' ' + (sel.getAttribute('data-option-name') || '');
          if (label.toLowerCase().indexOf('size') === -1) return;
          for (var i = 0; i < sel.options.length; i++) {
            if (widthOf(sel.options[i].value) === want) {
              sel.selectedIndex = i;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
              break;
            }
          }
        });
        var target = document.querySelector('.product__info-container') || document.querySelector('.product');
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  ready(function () { initDesc(); initSelectors(); initSizePicker(); });
})();